import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon ChatAirplaneIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const ChatAirplaneIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 5 19.950000000000003 20.1">
      <g
        strokeLinejoin="round"
        strokeLinecap="round"
        stroke="currentColor"
        clipPath="url(#a)"
      >
        <path d="m7.537 17.383 3.525 7.303 8.293-19.121L.235 13.86zm0 0L19.355 5.565" />
      </g>
      <defs>
        <clipPath id="a">
          <path
            d="m13.946 0 10.975 10.975L11.058 24.84.083 13.864z"
            fill="#fff"
          />
        </clipPath>
      </defs>
    </Icon>
  )
}
export default ChatAirplaneIcon
